module.exports = __webpack_public_path__ + "img/corner-left-down.6e1496d1.svg";